export default ({ request }) => ({
  changeOrderBatchListApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/list',
      method: 'post',
      data
    })
  },
  changeOrderBatchDetailApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/detail',
      method: 'post',
      data
    })
  },
  changeOrderBatchAddApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/add',
      method: 'post',
      data
    })
  },
  changeOrderBatchModiApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/modi',
      method: 'post',
      data
    })
  },
  changeOrderBatchDelApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/del',
      method: 'post',
      data
    })
  },

  changeOrderBatchGoodsListApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/goods/list',
      method: 'post',
      data
    })
  },
  changeOrderBatchGoodsDetailApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/goods/detail',
      method: 'post',
      data
    })
  },
  changeOrderBatchGoodsAddApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/goods/add',
      method: 'post',
      data
    })
  },
  changeOrderBatchGoodsModiApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/goods/modi',
      method: 'post',
      data
    })
  },
  changeOrderBatchGoodsAddListApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/goods/addList',
      method: 'post',
      data
    })
  },
  changeOrderBatchGoodsDelApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/goods/del',
      method: 'post',
      data
    })
  },
  changeAddBatchGoodsByPackingCodeApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/addBatchGoodsByPackingCode',
      method: 'post',
      data
    })
  },
  changeOrderBatchGoodsCheckDataApi(data = {}) {
    return request({
      url: '/factory/change/order/batch/checkData',
      method: 'post',
      data
    })
  },
})
